import axios from "axios";
import Config from "../../config";

const ReportConversationTime = params => {
    const {channel_id, start_date, end_date} = params
    return axios({
        method: "POST",
        url: (Config.url || '') + "/api/report/conversation-by-time",
        data: { channel_id, start_date, end_date }
    });
};

export default ReportConversationTime;
